import React from 'react';

import { Banner, InternetBanner, TariffCard } from '@/ui/index';
import PageTabs from '@/ui/PageTabs/PageTabs';
import GridProducts from '@/ui/GridProducts/GridProducts';

const Roaming = ({ data }) => {
  const renderTariff = (tariff, index) => {
    return <TariffCard key={`${index}_tariff`} item={tariff} />;
  };

  return (
    <div itemScope itemType='http://schema.org/Offer'>
      {data.tabs && <PageTabs tabs={data.tabs} pathname={'roaming'} />}
      {data?.mainBanner && <InternetBanner bannerData={data.mainBanner} />}
      {!!data?.offers?.length && (
        <div className={'small-margin'}>
          <GridProducts>{data.offers.map(renderTariff)}</GridProducts>
        </div>
      )}
      {data?.banner && (
        <Banner item={data.banner} href={'/roaming/prices-and-countries'} />
      )}
    </div>
  );
};

export default Roaming;
